import { render, staticRenderFns } from "./vehicleMonitoring-table.vue?vue&type=template&id=fbebe5e2"
import script from "./vehicleMonitoring-table.vue?vue&type=script&lang=js"
export * from "./vehicleMonitoring-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports